'use strict'

module.exports = {
    videoPosterPrefix: '', // video poster not in use (deprecated)
    videoSrcPrefix: 'addPanelData/sections/videos_en/videobox/videobox-thumb-'
}
